import { render, staticRenderFns } from "./DmsRolesTabsItems.vue?vue&type=template&id=47f545b5"
import script from "./DmsRolesTabsItems.vue?vue&type=script&lang=js"
export * from "./DmsRolesTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports